
const makeTable = (results) => {
    let state = {
        table: (new Array(5).fill('      ')).map(c => c.split('')),
        _x: -1,
        _y: -1,
        _tx: 0,
        _prev: '',
    }

    // "TTTBBPBP".split("")
    results.forEach(char => {
        state = addCharToTable(state, char);
    });

    return state.table;
}

const addCharToTable = (state, char) => {
    const table = _.cloneDeep(state.table)
    let x = state._x;
    let y = state._y;
    let tx = state._tx;
    let prev = state._prev;
   

    const goup = (c) => {
        try{
            if (tx > 0 || y > 5 || table[x][y + 1] !== ' ') {
                if (y > 0) { // dragon move to next column
                    tx ++;
                } else { 
                    tx = 0; 
                    x ++;
                }

                if ((x + tx) >= table.length) {
                    table.push('      '.split(''))
                }
                table[x + tx][y] = c
            } else {
                y ++;
                table[x][y] = c
            }
        } catch(e) {
            console.log(e)
            console.log('eee', JSON.stringify(table), x, y, y+1, state.table)
        }
    }

    const goright = (c) => {
        x += 1;
        y = 0;
        tx = 0;
        
        if ((x + tx) >= table.length) {
            table.push('      '.split(''))
        }

        table[x][y] = c
    }

    if (char === 'T' && x < 0) {
        goright(char)
        prev = 'T'
    } else
    if (char === prev || char === 'T' || prev === 'T') {
        if (prev === 'T') {
            prev = char;
        }
        goup(char)
    } else {
        prev = char;
        goright(char)
    }

    return {
        table,
        _x: x,
        _y: y,
        _tx: tx,
        _prev: prev,
    };
}

export default makeTable